import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(
  (theme, { isAddressBookPage, isListView } = {}) => ({
    fullName: {
      marginTop: isAddressBookPage ? theme.spacing(2) : 0,
    },
    company: {},
    addressType: {
      marginTop: theme.spacing(1.5),
      fontSize: '14px',
      lineHeight: '16px',
      [theme.breakpoints.down('lg')]: {
        WebkitLineClamp: isAddressBookPage && !isListView ? 2 : 1,
      },
      [theme.breakpoints.down('md')]: {
        marginTop: theme.spacing(0.5),
        fontSize: 12,
        lineHeight: '16px',
      },
    },
  }),
);
